    const MyAccountData = (state = {}, action) => {
    switch (action.type) {
        case 'MY_FAVOURITES' :
            return{
                ...state,
                favourites : action.payload
            }
        default:
            return state
        }
  }
  export default MyAccountData